import { Grid2, Typography } from "@mui/material";
import { ReactNode } from "react";

interface DataGridItemVerticalProps {
  label: string;
  children?: ReactNode | string;
  labelWidth?: number;
}

export function DataGridItemVertical({
  label,
  children,
  labelWidth = 5,
}: DataGridItemVerticalProps) {
  const isString = typeof children === "string";

  return (
    <>
      <Grid2 size={labelWidth}>
        <Typography color="text.secondary" variant="subtitle2" mb={0.5}>
          {label}
        </Typography>
      </Grid2>
      <Grid2 size={12 - labelWidth}>
        {isString ? (
          <Typography sx={{ color: "black" }}>{children}</Typography>
        ) : (
          children
        )}
      </Grid2>
    </>
  );
}
